/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioStatus } from './InternalApiScenarioStatus';
import {
    InternalApiScenarioStatusFromJSON,
    InternalApiScenarioStatusFromJSONTyped,
    InternalApiScenarioStatusToJSON,
    InternalApiScenarioStatusToJSONTyped,
} from './InternalApiScenarioStatus';

/**
 * 
 * @export
 * @interface InternalApiUpdateScenario
 */
export interface InternalApiUpdateScenario {
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateScenario
     */
    name?: string;
    /**
     * 
     * @type {InternalApiScenarioStatus}
     * @memberof InternalApiUpdateScenario
     */
    status?: InternalApiScenarioStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateScenario
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateScenario
     */
    typologyId?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUpdateScenario
     */
    internalId?: string;
}



/**
 * Check if a given object implements the InternalApiUpdateScenario interface.
 */
export function instanceOfInternalApiUpdateScenario(value: object): value is InternalApiUpdateScenario {
    return true;
}

export function InternalApiUpdateScenarioFromJSON(json: any): InternalApiUpdateScenario {
    return InternalApiUpdateScenarioFromJSONTyped(json, false);
}

export function InternalApiUpdateScenarioFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUpdateScenario {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : InternalApiScenarioStatusFromJSON(json['status']),
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'typologyId': json['typologyId'] == null ? undefined : json['typologyId'],
        'internalId': json['internalId'] == null ? undefined : json['internalId'],
    };
}

export function InternalApiUpdateScenarioToJSON(json: any): InternalApiUpdateScenario {
    return InternalApiUpdateScenarioToJSONTyped(json, false);
}

export function InternalApiUpdateScenarioToJSONTyped(value?: InternalApiUpdateScenario | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'status': InternalApiScenarioStatusToJSON(value['status']),
        'categoryId': value['categoryId'],
        'typologyId': value['typologyId'],
        'internalId': value['internalId'],
    };
}

